export default "__VITE_ASSET__db959686__"